import React from 'react'

import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'

import * as S from './DateCell.styled'
import type { Props } from './types'

export const DateCell = ({ date }: Props) => {
  return (
    <S.Container>
      <TimezonedDateString date={date} format="MMM D, YYYY" />
      <TimezonedDateString date={date} format="h:mma" withTimezoneAbbreviation={false} />
    </S.Container>
  )
}
